module.exports = __webpack_public_path__ + "media/images/logo_evlka-d5a23152c96205f9e79167101b36b285.png";